<template>
  <div>
    <v-container class="py-0 px-0">
      <v-card tile>
        <v-card-title>Berita Acara Kembali</v-card-title>
        <v-card-text class="py-0">
          <v-container class="px-0">
            <v-row>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-text-field
                  label="Kode TTB"
                  dense
                  hide-details
                  type="text"
                  v-model="formData.kodettb"
                  @keydown.enter="searchBA"
                  autofocus
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-text-field
                  label="Tgl BA Kembali"
                  dense
                  hide-details
                  type="date"
                  v-model="formData.tgl_ba_kembali"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" class="fit-content">
                <v-text-field
                  label="Keterangan"
                  dense
                  hide-details
                  type="text"
                  v-model="formData.keterangan_ba"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2" class="fit-content">
                <v-btn
                  color="primary"
                  :loading="loading.saveData"
                  :disabled="loading.saveData"
                  @click="saveData"
                  small
                >
                  Simpan
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

      <v-data-table
        :headers="dataHeaders"
        :items="data"
        :loading="loading.fetchData"
        :items-per-page="10"
        class="elevation-1 mt-2"
        dense
      >
        <template v-slot:item.tgl_ba_kembali="{ item }">
          {{ item.tgl_ba_kembali || "-" }}
        </template>
        <template v-slot:item.tgl_kirim_ba="{ item }">
          {{ item.tgl_kirim_ba || "-" }}
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "BeritaAcaraKembali",
  data() {
    return {
      loading: {
        saveData: false,
        fetchData: false
      },
      formData: {
        kodettb: "",
        tgl_ba_kembali: "",
        keterangan_ba: ""
      },
      dataHeaders: [
        { text: "Kode TTB", value: "kodettb" },
        { text: "Tgl BA Kembali", value: "tgl_ba_kembali" },
        { text: "Tgl Kirim BA", value: "tgl_kirim_ba" },
        { text: "Keterangan", value: "keterangan_ba" }
      ],
      data: []
    };
  },
  watch: {
    "formData.kodettb"(val) {
      if (val) this.formData.kodettb = val.toUpperCase();
    }
  },
  methods: {
    async fetchData() {
      this.loading.fetchData = true;

      await axios
        .get(`berita-acara`)
        .then(res => {
          this.data = res.data;
          this.loading.fetchData = false;
        })
        .catch(err => {
          this.loading.fetchData = false;
          alert(err.response.data.message);
        });
    },
    async searchBA() {
      this.loading.fetchData = true;

      await axios
        .get(`berita-acara?kodettb=${this.formData.kodettb}`)
        .then(res => {
          this.data = res.data;
          this.loading.fetchData = false;
        })
        .catch(err => {
          this.loading.fetchData = false;
          alert(err.response.data.message);
        });
    },
    async saveData() {
      if (!this.formData.kodettb || !this.formData.tgl_ba_kembali) {
        alert("Kode TTB dan Tgl BA Kembali harus diisi");
        return;
      }

      this.loading.saveData = true;

      await axios
        .post(`berita-acara/update-kembali`, this.formData)
        .then(res => {
          this.loading.saveData = false;
          this.fetchData();
          this.resetFormData();
        })
        .catch(err => {
          this.loading.saveData = false;
          alert(err.response.data.message);
        });
    },
    resetFormData() {
      this.formData.kodettb = "";
      this.formData.tgl_ba_kembali = "";
      this.formData.keterangan_ba = "";
    }
  },
  created() {
    this.fetchData();
  }
};
</script>

<style scoped>
.fit-content {
  height: fit-content;
}
</style>
